<template>
    <div class="vehicule">
        <v-container class="pa-1">
            <v-row dense>
                <v-col cols="12" class="text-center">
                    <v-btn color="primary" rounded @click="sendReprise" depressed>Envoyer un lien de reprise</v-btn>
                </v-col>
                <v-col cols="12">
                    <v-card tile v-if="reprise">
                        <v-card-title class="headline" @click="$router.push({name: 'RepriseForm', params: { code: code, id: lead.id, mode:'edit' }})">
                            <div class="leftside">
                                <i class="mdi mdi-car"></i> {{$t('messages.details.reprise')}} 
                            </div>
                            <i class="mdi mdi-lead-pencil"></i>
                        </v-card-title>
                        <v-card-text class="content">
                            <p class="marque" v-if="reprise.marque != '' || reprise.modele != ''"><span>{{reprise.marque}}</span> <span v-if='reprise.modele'>{{reprise.modele}}</span></p>
                            <p v-if="reprise.energie">{{reprise.energie}}</p>
                            <p v-if="reprise.boite">{{reprise.boite}}</p>
                            <p v-if="reprise.infos_reprise !== undefined">Kilométrage : {{reprise.kilometrage}}</p>
                            <p v-if="reprise.infos_reprise !== undefined">Options : {{reprise.infos_reprise.options}}</p>
                            <p v-if="repriseFinancementEnCours">{{repriseFinancementEnCours}}</p>
                            <p v-if="reprise.fin_financement">{{$t('messages.reprise.end_financement')}} : {{reprise.fin_financement}}</p>
                            <p v-if="reprise.date_achat">{{$t('messages.details.achat')}} : {{reprise.date_achat}}</p>
                            <p v-if="reprise.date_mec">{{$t('messages.details.mec')}} : {{reprise.date_mec}}</p>
                            <p v-if="reprise.commentaire">{{reprise.commentaire}}</p>
                            <div v-if="entretiensCount > 0">
                                <p>Entretiens effectués dans les 12 derniers mois :</p>
                                <p v-if="reprise.infos_reprise.entretiens['courroie de distribution']">- Courroie de distribution</p>
                                <p v-if="reprise.infos_reprise.entretiens['disques de frein']">- Disques de frein</p>
                                <p v-if="reprise.infos_reprise.entretiens['plaquette de frein']">- Plaquettes de frein</p>
                                <p v-if="reprise.infos_reprise.entretiens['pneus arrière']">- Pneus arrière</p>
                                <p v-if="reprise.infos_reprise.entretiens['pneus avant']">- Pneus avant</p>
                                <p v-if="reprise.infos_reprise.entretiens['revision']">- Revision</p>
                            </div>
                            <div v-if="reprise.infos_reprise && reprise.infos_reprise.photos && reprise.infos_reprise.photos.length > 0">
                                <p>Photos du véhicule :</p>
                                <v-container>
                                    <v-row dense class="justify-space-between">
                                        <v-col cols="3" v-for="(thumb, index) in reprise.infos_reprise.photos" :key="index" @click="openPhotos(index)">
                                            <v-img :src="thumb.value+'?option=x70,y70,crop'" contain />
                                        </v-col>
                                    </v-row>
                                </v-container>
                                <v-dialog
                                v-model="showPhotos"
                                max-width="320"
                                    ref='photosCarousel'
                                >
                                   <v-carousel
                                        height="auto"
                                        hide-delimiters
                                        light
                                        :show-arrows="false"
                                        ref="carousel"
                                    >
                                    <v-carousel-item v-for="(thumb, index) in reprise.infos_reprise.photos" :key="index">
                                        <v-img :src="thumb.value" contain />
                                        <p class="label text-center">{{thumb.label}}</p>
                                    </v-carousel-item>
                                </v-carousel>
                                </v-dialog>
                            </div>
                            <div v-if="showEtat">
                                <p>Etat du véhicule :</p>
                                <v-container class="py-0" v-if="etatGlobal.length > 0">
                                    <v-row dense class="justify-space-between">
                                        <v-col cols="3" v-for="(thumb, index) in etatGlobal" :key="index"  @click="openEtatsPhotos(index)">
                                            <v-img :src="thumb.value+'?option=x70,y70,crop'" contain />
                                        </v-col>
                                    </v-row>
                                </v-container>
                                <v-dialog
                                v-model="showEtatsPhotos"
                                max-width="320"
                                    ref='photosEtatsCarousel'
                                >
                                   <v-carousel
                                        height="auto"
                                        hide-delimiters
                                        light
                                        :show-arrows="false"
                                        ref="carouselEtats"
                                    >
                                    <v-carousel-item v-for="(thumb, index) in etatGlobal" :key="index">
                                        <v-img :src="thumb.value" contain />
                                        <p class="label text-center">{{thumb.label}}</p>
                                    </v-carousel-item>
                                </v-carousel>
                                </v-dialog>
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card tile v-if="!reprise" >
                        <v-card-title class="headline" @click="$router.push({name: 'RepriseForm', params: { code: code, id: lead.id, mode:'create' }})">
                            <div class="leftside">
                                <i class="mdi mdi-car"></i> {{$t('messages.details.reprise')}} 
                            </div>
                            <i class="mdi mdi-plus-circle"></i>
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col cols='12' >
                    <v-card tile v-if='interet'>
                        <v-card-title class="headline" @click="$router.push({name: 'InteretForm', params: { code: code, id: lead.id, mode:'edit' }})">
                            <div class="leftside">
                                <i class="mdi mdi-cart"></i> {{$t('messages.details.interet')}} 
                            </div>
                            <i class="mdi mdi-lead-pencil"></i>
                        </v-card-title>
                        <v-card-text class="content">
                            <p class="marque" v-if="interet.marque != '' || interet.modele != ''">
                                <span>{{ interet.marque }}</span> 
                                <span v-if="interet.modele"> {{interet.modele}}</span> 
                                <span v-if="interet.etat"> ({{interet.etat}})</span>
                            </p>
                            <p v-if="interet.energie">{{interet.energie}}</p>
                            <p v-if="interet.boite">Boite {{interet.boite}}</p>
                            <p v-if="interet.budget">{{$t('messages.details.budget')}} : {{interet.budget}} €</p>
                            <p v-if="interet.financement">{{$t('messages.details.financement')}} : {{interet.financement}}</p>
                        </v-card-text> 
                    </v-card>
                    <v-card tile v-if='!interet'> 
                        <v-card-title class="headline" @click="$router.push({name: 'InteretForm', params: { code: code, id: lead.id, mode:'create' }})">
                            <div class="leftside">
                                <i class="mdi mdi-cart"></i> {{$t('messages.details.interet')}} 
                            </div>
                            <i class="mdi mdi-plus-circle"></i>
                        </v-card-title> 
                    </v-card>
                </v-col>
            </v-row> 
        </v-container>
        <v-dialog
        v-model="repriseSent"
        width="500"
        >
            <v-card>
                <v-card-text class="pt-2">
                    <p class="pt-4">Le lien pour l'application de reprise a bien été envoyé au client</p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="repriseSent = false"
                >
                    OK
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
        v-model="repriseNoPhone"
        width="500"
        >
        <v-card>
            <v-card-text>
            <h2 class="pt-4">Erreur</h2> 
            <p class="mt-2">Il semblerait que le lead n'a pas de numéro de téléphone. Il est nécessaire pour pouvoir envoyer le lien de l'application de reprise.</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="repriseNoPhone = false"
            >
                Ok
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
export default {
    props: ['code', 'lead'],   
    data() {
        return {
            reprise: {},
            interet: {},
            showPhotos: false,
            photoIndex:"",
            entretiensCount: 0,
            showEtatsPhotos: false,
            repriseNoPhone: false,
            repriseSent: false,
            etatIndex: ""
        }
    },
    methods: {
        sendReprise: function() {
            if(this.lead.telephone_mobile){
                this.$store.dispatch('setLoader', true).then((e) => {
                    this.$store.dispatch('sendRepriseLink', this.lead.id).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        this.repriseSent = true;
                    })
                })
            }else {
                this.repriseNoPhone = true
            }
            
        },
        openPhotos: function(index) {
            this.photoIndex = index;
            this.showPhotos = true;
        },
        openEtatsPhotos: function(index) {
            this.etatIndex = index;
            this.showEtatsPhotos = true;
        }
    },
    watch: {
        showPhotos: function(val){
            if(val == true && this.$refs.carousel){
                this.$refs.carousel.internalValue = this.photoIndex
            }
        },
        showEtatsPhotos: function(val){
            if(val == true && this.$refs.carouselEtats){
                this.$refs.carouselEtats.internalValue = this.etatIndex
            }
        },
    },
    computed: {
        etatGlobal: function() {
            const etatGlobal = [];
            const arriereTest = this.reprise.infos_reprise.etat.arriere.filter((e) => e.value != "")
            if(this.reprise.infos_reprise.etat){
                if(arriereTest.length > 0){
                    arriereTest.forEach((value) => {
                        value.label = "Arrière - "+value.label
                        etatGlobal.push(value)
                    })
                }
                const avantTest = this.reprise.infos_reprise.etat.avant.filter((e) => e.value != "")
                if(avantTest.length > 0){
                    avantTest.forEach((value) => {
                        value.label = "Avant - "+value.label
                        etatGlobal.push(value) 
                    })
                }
                const coteGauche = this.reprise.infos_reprise.etat.cotegauche.filter((e) => e.value != "")
                if(coteGauche.length > 0){
                    coteGauche.forEach((value) => {
                        value.label = "Coté Gauche - "+value.label
                        etatGlobal.push(value)
                    })
                }
                const coteDroit = this.reprise.infos_reprise.etat.cotedroit.filter((e) => e.value != "")
                if(coteDroit.length > 0){
                    coteDroit.forEach((value) => {
                        value.label = "Coté Droit - "+value.label
                        etatGlobal.push(value)
                    })
                }
                const Interieur = this.reprise.infos_reprise.etat.interieur.filter((e) => e.value != "")
                if(Interieur.length > 0){
                    Interieur.forEach((value) => {
                        value.label = "Intérieur - "+value.label
                        etatGlobal.push(value)
                    })
                }
                const Toit = this.reprise.infos_reprise.etat.toit.filter((e) => e.value != "")
                if(Toit.length > 0){
                    Toit.forEach((value) => {
                        value.label = "Toit - "+value.label
                        etatGlobal.push(value)
                    })
                }
            }
            return etatGlobal
        },
        showEtat: function(){
            const etats = this.reprise.infos_reprise.etat 
            console.log(etats)
            if(etats !== null && (etats.arriere.length > 0 || etats.avant.length > 0 || etats.cotedroit.length > 0 || etats.cotegauche.length > 0 || etats.interieur.length > 0 || etats.toit.length > 0)){
                return true
            }
            return false
        },
        repriseFinancementEnCours: function(){
            dayjs.extend(customParseFormat)
            if(this.reprise.financement == "OUI") {
                if(dayjs().isBefore(dayjs(this.reprise.fin_financement, "DD/MM/YYYY"))){
                    //Financement en cours
                    return this.$t('messages.details.financement_cours')
                } else {
                    //Financement Fini
                    return this.$t('messages.details.financement_termine')
                }
            } else {
                return false
            }
        }
    },
    created() {
        this.reprise = this.lead.vehicules.find((e) => e.type == 'REPRISE')
        this.interet = this.lead.vehicules.find((e) => e.type == 'INTERET')
        if(this.reprise && this.reprise.infos_reprise.entretiens){
            if(this.reprise.infos_reprise.entretiens['courroie de distribution']){
                this.entretiensCount++
            }
            if(this.reprise.infos_reprise.entretiens['disques de frein']){
                this.entretiensCount++
            }
            if(this.reprise.infos_reprise.entretiens['plaquette de frein']){
                this.entretiensCount++
            }
            if(this.reprise.infos_reprise.entretiens['pneus arrière']){
                this.entretiensCount++
            }
            if(this.reprise.infos_reprise.entretiens['pneus avant']){
                this.entretiensCount++
            }
            if(this.reprise.infos_reprise.entretiens['revision']){
                this.entretiensCount++
            }
        }
    },
}
</script>
<style lang="scss">
    .vehicule {
        .headline {
            border-bottom:1px solid #CCC;
            color: #081525;
            display:flex;
            align-items: center;
            justify-content: space-between;
            .leftside {
                display:flex;
                align-items: center;
                justify-content: flex-start;
                i {
                    margin-right:10px;
                }
            }
        }
        .content {
            color:black;
            p {
                color:black;
                margin:0;
                &.marque {
                    margin: 10px 0;
                }
            }
        }
        
    }
    .label {
        color:white;
        background-color: rgba(0,0,0,0.4);
        margin-bottom:0 !important;
    }
</style>